import { combineReducers } from 'redux';
import client from './index';

const clientReducer = combineReducers({
  client,
});

export default clientReducer;
